import PortfolioPanel from './PortfolioPanel';

export default PortfolioPanel;
